module.exports = __webpack_public_path__ + "img/first-day-6.dc1aaec0.webp";